import React from "react";
import logo from "../images/ston1.jpg";
import Navbars from "./Navbar";

const AboutUs = () => {
  return (
    <>
      <Navbars />
      <div className="px-6 py-10 md:px-20 md:py-16 bg-white text-gray-800">
        {/* Logo Section */}
        <div className="flex justify-start md:justify-start mb-10">
          <img
            src={logo}
            alt="StoneAge Films Logo"
            className="w-60 h-auto object-contain md:w-[550px] md:h-auto" // 👈 Increased size for desktop
          />
        </div>

        {/* Main Heading */}
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center md:text-left">
          StoneAge Films: Crafted Stories, Timeless Impact
        </h2>

        {/* About Text */}
        <div className="space-y-6 text-center md:text-left">
          <p>
            At <strong>StoneAge Films</strong>, we don’t just produce content—we
            craft experiences that inspire, connect, and endure. Every project
            is more than a brief; it’s an opportunity to build something
            meaningful and unforgettable.
          </p>

          <p>
            We’ve had the privilege of collaborating with some of the world’s
            most impactful brands. Each project stands as a testament to our
            belief in bold storytelling, sharp execution, and an unwavering
            pursuit of excellence.
          </p>

          <p>
            From high-octane TV commercials to disruptive digital campaigns, we
            transform ideas into stunning visual narratives. Our work
            resonates—creating moments that stay with audiences long after the
            first watch.
          </p>
        </div>

        {/* What Drives Us */}
        <div className="mt-10">
          <h3 className="text-xl md:text-2xl font-semibold mb-3 text-center md:text-left">
            What Drives Us?
          </h3>
          <ul className="list-disc list-inside space-y-2 text-center md:text-left">
            <li>
              <strong>The Power of Stories:</strong> Stories shape the world. We
              shape them to drive your brand forward.
            </li>
            <li>
              <strong>Creativity Without Compromise:</strong> Pushing boundaries
              to craft work that’s authentic, bold, and original.
            </li>
            <li>
              <strong>Collaboration:</strong> The best ideas come from shared
              vision and trust. Your story is our passion.
            </li>
          </ul>
        </div>

        {/* Why Section */}
        <div className="mt-10">
          <h3 className="text-xl md:text-2xl font-semibold mb-3 text-center md:text-left">
            Why StoneAge Films?
          </h3>
          <p className="mb-4 text-center md:text-left">
            No two brands are the same. That’s why we tailor every campaign to
            reflect your voice and values, ensuring your message stands out. Our
            approach combines technical expertise, creative ingenuity, and a
            commitment to deliver on time and within budget.
          </p>

          <ul className="list-disc list-inside space-y-2 text-center md:text-left">
            <li>
              <strong>Think Bigger:</strong> Our creative team turns even the
              simplest ideas into ambitious campaigns.
            </li>
            <li>
              <strong>Work Smarter:</strong> Streamlined production processes
              deliver premium results without delays.
            </li>
            <li>
              <strong>Perfect the Details:</strong> From first draft to final
              edit, we obsess over every frame.
            </li>
          </ul>
        </div>

        {/* Closing Section */}
        <div className="mt-10">
          <h3 className="text-xl md:text-2xl font-semibold mb-3 text-center md:text-left">
            Let’s Make Magic Together
          </h3>
          <p className="text-base leading-relaxed text-center md:text-left">
            Your brand deserves more than just a production house—it deserves a
            partner who shares your vision and amplifies your story. At{" "}
            <strong>StoneAge Films</strong>, we’re ready to collaborate,
            innovate, and bring your ideas to life in ways you’ve never
            imagined.
          </p>
        </div>

        {/* Social Media Section */}
        <div className="py-6 flex justify-center md:justify-start bottom-8 space-x-6 text-lg md:text-xl">
          <a
            href="mailto:shirley@stoneagefilms.in"
            className="hover:text-gray-500 transition-colors duration-300"
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 512 512"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"></path>
            </svg>
          </a>

          <a
            href="https://www.linkedin.com/company/stoneage-films/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-500 transition-colors duration-300"
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 448 512"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path>
            </svg>
          </a>

          <a
            href="https://vimeo.com/stoneagefilms"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-500 transition-colors duration-300"
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 448 512"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"></path>
            </svg>
          </a>

          <a
            href="https://www.facebook.com/share/HUgWcWzv7WNL9992/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-500 transition-colors duration-300"
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 512 512"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
            </svg>
          </a>

          <a
            href="https://www.instagram.com/stoneagefilms.in/#"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-500 transition-colors duration-300"
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 448 512"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
            </svg>
          </a>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
